import { render } from "./ViewLivraison.vue?vue&type=template&id=0c3c0db3&ts=true"
import script from "./ViewLivraison.vue?vue&type=script&lang=ts"
export * from "./ViewLivraison.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__